/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function() {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        beforeSend: function(jqxhr, settings) {
          $body.trigger('ajaxCart.beforeAddItem', form);
        },
        success: function(line_item) {
          if (typeof callback === 'function') {
            callback(line_item, form);
          } else {
            ShopifyAPI.onItemAdded(line_item, form);
          }
          $body.trigger('ajaxCart.afterAddItem', [line_item, form]);
        },
        error: function(XMLHttpRequest, textStatus) {
          if (typeof errorCallback === 'function') {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
          $body.trigger('ajaxCart.errorAddItem', [XMLHttpRequest, textStatus]);
        },
        complete: function(jqxhr, text) {
          $body.trigger('ajaxCart.completeAddItem', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  var cartUrl = '/cart.js';
  if (jQuery('.cart-drawer').attr('data-wholesale-cart') === 'true') {
    cartUrl += '?_wholesale=' + Date.now();
  }
  jQuery.getJSON(cartUrl, function(cart) {
    if (typeof callback === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body);
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('ajaxCart.beforeChangeItem', [line, quantity]);
    },
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('ajaxCart.completeChangeItem', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Add item by variant ID (for upsells)
ShopifyAPI.addItemById = function(variantId, quantity, callback, errorCallback) {
    var $body = $(document.body);
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: quantity || 1
      },
      dataType: 'json',
      success: function(line_item) {
        if (typeof callback === 'function') {
          callback(line_item);
        }
        $body.trigger('ajaxCart.afterAddItem', [line_item]);
      },
      error: function(XMLHttpRequest, textStatus) {
        if (typeof errorCallback === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
      }
    };
    jQuery.ajax(params);
  };

var ajaxCart = (function(module, $) {
  'use strict';
  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  function isWholesaleCart() {
    return $('.cart-drawer').attr('data-wholesale-cart') === 'true';
  }

  function wholesaleCartMessage(cart) {
    if ((cart.items || []).some(function(item) { return item.quantity < 5; })) {
      return 'A minimum of 5 units per item is required.';
    }
    if (!Number.isFinite(cart.original_total_price)) return 'Please refresh your cart to verify the wholesale order minimum.';
    if (cart.original_total_price < 10000) {
      return 'Add ' + slate.Currency.formatMoney(10000 - cart.original_total_price, settings.moneyFormat) + ' more to reach the $100 wholesale order minimum.';
    }
    return '';
  }

  // Private plugin variables
  var $formContainer,
      $addToCart,
      $cartCountSelector,
      $cartCostSelector,
      $cartContainer;

  // Private functions
  var updateCountPrice,
      formOverride,
      itemAddedCallback,
      itemErrorCallback,
      cartUpdateCallback,
      buildCart,
      buildCartBar,
      buildCartUpsells,
      cartCallback,
      adjustCart,
      adjustCartCallback,
      qtySelectors,
      validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function(options) {
    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: '.cart-count',
      cartCostSelector: null,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);
    if (isWholesaleCart()) {
      settings.moneyFormat = String(settings.moneyFormat).replace(/amount_no_decimals/g, 'amount');
    }

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    
    // Setup upsell click handlers
    $body.on('click', '.upsell-add-btn', function(e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.hasClass('is-adding')) return;

    var variantId = $btn.data('variant-id');
    var handle = $btn.data('handle');

    $btn.text('Adding...').addClass('is-adding');

    function doAdd(id) {
      ShopifyAPI.addItemById(id, 1, function() {
        $btn.text('Added!').removeClass('is-adding').addClass('added');
        ShopifyAPI.getCart(cartUpdateCallback);
      }, function() {
        $btn.text('+ Add').removeClass('is-adding');
      });
    }

    if (variantId && String(variantId) !== 'null') {
      doAdd(variantId);
    } else if (handle) {
      $.getJSON('/products/' + handle + '.js', function(product) {
        if (product.variants && product.variants.length > 0) {
          doAdd(product.variants[0].id);
        } else {
          $btn.text('+ Add').removeClass('is-adding');
        }
      }).fail(function() {
        $btn.text('+ Add').removeClass('is-adding');
      });
    } else {
      $btn.text('+ Add').removeClass('is-adding');
    }
      });
  };

  loadCart = function() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if(cart.item_count > 1 || cart.item_count == 0 ){
        $("#inner_count").html(cart.item_count + " Items");
      }else{
        $("#inner_count").html(cart.item_count + " Item");
      }
      $cartCountSelector.parent().addClass('filled');
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $cartCountSelector.parent().removeClass('filled');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(
        slate.Currency.formatMoney(cart.total_price, settings.moneyFormat)
      );
    }
  };

  formOverride = function() {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(
        evt.target,
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };

  itemAddedCallback = function() {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function(XMLHttpRequest) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (data.message) {
      if (data.status === 422) {
        $formContainer.after(
          '<div class="errors qty-error">' + data.description + '</div>'
        );
      }
    }
  };

  cartUpdateCallback = function(cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function(cart) {
    var focusedQuantity;
    if (isWholesaleCart()) {
      if (wholesaleSaving || Object.keys(wholesalePending).length) return;
      var active = document.activeElement;
      if (active && active.matches('.cart-drawer .ajaxcart__qty-num')) {
        var focusedItem = wholesaleDisplayed[Number(active.getAttribute('data-line')) - 1];
        if (focusedItem) focusedQuantity = { key: focusedItem.key, value: active.value, start: active.selectionStart, end: active.selectionEnd };
      }
      wholesaleConfirmed = cart;
      wholesaleDisplayed = cart.items.slice();
    }
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      var source = $('#CartEmptyTemplate').html(),
          template = Handlebars.compile(source);
      $cartContainer.append(template());
      cartCallback(cart);
      buildCartBar(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $('#CartTemplate').html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      var prodImg;
      if (cartItem.image !== null) {
        prodImg = cartItem.image
        .replace(/(\.[^.]*)$/, '_medium$1')
        .replace('http:', '');
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      if (cartItem.properties !== null) {
        cartItem.xoBundleImages = String(cartItem.properties._xo_bundle_images || '').split('|').filter(Boolean);
        cartItem.xoBundleLabels = String(cartItem.properties._xo_bundle_labels || '').split('|').filter(Boolean);

        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }
      
      var CartitemPrice = cartItem.price/100;
      var CartLinePrice = CartitemPrice.toFixed();
      var CartItemPrice = CartLinePrice*100;
      var CartItemFinalPrice = isWholesaleCart() ? cartItem.price : Math.round(CartItemPrice);

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        vendor: cartItem.vendor,
        originalPrice: slate.Currency.formatMoney((cartItem.line_price + cartItem.total_discount), settings.moneyFormat), 
        price: slate.Currency.formatMoney(isWholesaleCart() ? cartItem.final_price : CartItemFinalPrice, settings.moneyFormat),
        discountedPrice: slate.Currency.formatMoney(
          cartItem.price - cartItem.total_discount / cartItem.quantity,
          settings.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied:
        cartItem.price === cartItem.price - cartItem.total_discount
        ? false
        : true,
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ),
      totalCartDiscount:
      cart.total_discount === 0
      ? 0
      : theme.strings.cartSavings.replace(
        '[savings]',
        slate.Currency.formatMoney(
          cart.total_discount,
          settings.moneyFormat
        )
      )
    };

    $cartContainer.append(template(data));

    if (isWholesaleCart()) {
      var wholesaleMessage = wholesaleCartMessage(cart);
      $cartContainer.find('[data-wholesale-drawer-status]').text(wholesaleMessage);
      $cartContainer.find('.cart__checkout').prop('disabled', !!wholesaleMessage);
      $cartContainer.find('.ajaxcart__qty-num').attr('min', 5);
      if (focusedQuantity) {
        var focusedIndex = cart.items.findIndex(function(item) { return item.key === focusedQuantity.key; });
        var replacement = $cartContainer.find('.ajaxcart__qty-num').get(focusedIndex);
        if (focusedIndex >= 0 && replacement) {
          replacement.value = focusedQuantity.value;
          replacement.focus({preventScroll: true});
          replacement.setSelectionRange(focusedQuantity.start, focusedQuantity.end);
        }
      }
    }

    cartCallback(cart);
    buildCartBar(cart);
    buildCartUpsells(cart);
  };

  buildCartBar = function(cart) {
    if (isWholesaleCart()) {
      var remaining = Math.max(0, 10000 - cart.original_total_price);
      $('[data-wholesale-progress]').val(Math.min(10000, Math.max(0, cart.original_total_price)));
      $('[data-wholesale-progress-message]').text(remaining > 0
        ? 'Add ' + slate.Currency.formatMoney(remaining, settings.moneyFormat) + ' more to reach the $100 wholesale order minimum.'
        : '$100 wholesale order minimum reached!');
      return;
    }
    var giftThreshold = parseInt($('.xo-rewards').attr('data-xo-gift-threshold'), 10) || 6500;
    var shippingThreshold = parseInt($('.xo-rewards').attr('data-xo-shipping-threshold'), 10) || 7500;
    var subtotal = (cart.items || []).reduce(function(total, item) {
      return total + (item.properties && String(item.properties._xo_free_gift) === 'true'
        ? 0
        : (item.final_line_price != null ? item.final_line_price : item.line_price));
    }, 0);
    var giftUnlocked = subtotal >= giftThreshold;
    var giftRemaining = Math.max(0, giftThreshold - subtotal);
    var shippingRemaining = Math.max(0, shippingThreshold - subtotal);
    var progress = subtotal >= shippingThreshold
      ? 100
      : subtotal >= giftThreshold
        ? 70 + ((subtotal - giftThreshold) / (shippingThreshold - giftThreshold)) * 30
        : (subtotal / giftThreshold) * 70;
    progress = Math.min(100, Math.max(0, progress));

    $('.fs-bar-wrapper').toggleClass('gift-unlocked', giftUnlocked).toggleClass('unlocked', subtotal >= shippingThreshold);
    $('.fs-bar-filler').width(progress + '%');
    $('#fs-bar-message').prop('hidden', subtotal >= shippingThreshold).html(subtotal >= shippingThreshold
      ? ''
      : giftUnlocked
        ? '<strong>Free gift unlocked!</strong><br><span>' + slate.Currency.formatMoney(shippingRemaining, settings.moneyFormat) + ' away from free 2-day shipping</span>'
        : '<strong>' + slate.Currency.formatMoney(giftRemaining, settings.moneyFormat) + ' away</strong> from a free gift<br><span>' + slate.Currency.formatMoney(shippingRemaining, settings.moneyFormat) + ' away from free 2-day shipping</span>');
  };

  /*============================================================================
    Build Cart Upsells - Title-based search with Shopify API fallback
  ==============================================================================*/
  function buildCartUpsells(cart) {
    if (isWholesaleCart()) return;
    // Remove ALL existing upsells first
    $('.cart-upsells-section').remove();
    $('[data-cart-upsells]').remove();
    $('.cart-upsells').remove();

    // Prevent multiple simultaneous calls
    if (window.buildingUpsells) return;
    window.buildingUpsells = true;

    if (cart.item_count === 0) {
      window.buildingUpsells = false;
      return;
    }

    // Get the first product in cart to base recommendations on
    var firstItem = cart.items[0];
    var productId = firstItem.product_id;
    var productTitle = firstItem.product_title || '';

    // Extract keywords from title for relevance scoring and search
    var ignoreWords = ['the','a','an','and','or','for','with','of','to','in','on','at','by','that','this','its','pack','set','count','piece','pcs'];
    var lineName = productTitle.toLowerCase().split(' - ')[0];
    var titleKeywords = lineName.replace(/[^a-z0-9\s]/g, '').split(/\s+/).filter(function(w) {
      return w.length > 2 && ignoreWords.indexOf(w) === -1;
    });
    // Use first keyword only — Shopify ANDs multi-word queries, so "wifey claw clip" returns nothing
    var searchTerm = titleKeywords[0] || '';

    // Generic + category tags to skip when scoring
    var genericTags = ['party','faire','gift','giftable','gifts','accessory','accessories','decorations','party supplies','party decorations','party favors','wearable','party neutral'];
    var categoryTags = ['confetti','sunglasses','sunnies','sash','cups','cup','banner','balloon','balloons','hat','headband','tiara','necklace','tattoos','temporary tattoos','stickers','napkins','plates','straws','bags','tote','candle','candles','pin','pins','ring dish','jewelry dish','jewelry tray','trinket tray','sleep mask','bandana','handkerchief','journal','notebook','bucket hat','headscarf','scarf'];

    var sourceTags = [];
    var sourceType = '';
    var occasionKeys = ['bachelorette','birthday','baby shower','bridal shower','kids party','halloween','christmas','holiday','st patricks','easter','valentines','new years'];
    var sourceOccasion = '';

    function relevanceScore(rec) {
      var score = 0;
      var recTags = (rec.tags || []).map(function(t) { return t.toLowerCase(); });
      sourceTags.forEach(function(tag) {
        if (genericTags.indexOf(tag) === -1 && categoryTags.indexOf(tag) === -1 && recTags.indexOf(tag) !== -1) score++;
      });
      var recWords = rec.title.toLowerCase().replace(/[^a-z0-9\s]/g, '').split(/\s+/);
      titleKeywords.forEach(function(kw) {
        if (recWords.indexOf(kw) !== -1) score += 2;
      });
      if (sourceType && rec.type && rec.type.toLowerCase() === sourceType) score -= 3;
      // Penalize products from a different occasion (e.g. bridal on a birthday page)
      if (sourceOccasion && recTags.length > 0) {
        var recHasCurrent = false;
        var recHasDifferent = false;
        recTags.forEach(function(rt) {
          occasionKeys.forEach(function(occ) {
            if (rt.indexOf(occ) !== -1) {
              if (occ === sourceOccasion) recHasCurrent = true;
              else recHasDifferent = true;
            }
          });
        });
        if (recHasDifferent && !recHasCurrent) score -= 10;
      }
      return score;
    }

    // Get all product IDs in cart to exclude from recommendations
    var cartProductIds = cart.items.map(function(item) {
      return item.product_id;
    });

    function renderUpsells(recommendations) {
      if (recommendations.length === 0) {
        window.buildingUpsells = false;
        return;
      }

      var upsellsHtml = '<div class="cart-upsells">';
      upsellsHtml += '<div class="cart-upsells__title">🎉 Complete Your Party</div>';
      upsellsHtml += '<div class="cart-upsells__products">';

      recommendations.forEach(function(product) {
        var price = product.price ? String(product.price).replace(/[^0-9.]/g, '') : '0';
        price = (parseFloat(price) < 100 ? parseFloat(price) : parseFloat(price) / 100).toFixed(0);

        var comparePrice = product.compare_at_price ? String(product.compare_at_price).replace(/[^0-9.]/g, '') : null;
        if (comparePrice) {
          comparePrice = (parseFloat(comparePrice) < 100 ? parseFloat(comparePrice) : parseFloat(comparePrice) / 100).toFixed(0);
        }

        var img = product.image || product.featured_image || '';
        if (typeof img === 'object' && img.url) img = img.url;
        var imgSrc = img ? img.replace(/(\.[^.]*)$/, '_small$1') : '';

        var variantId = (product.variants && product.variants.length > 0 && product.variants[0].id) ? product.variants[0].id : null;

        var titleParts = product.title.split(' - ');
        var mainTitle = titleParts[0];
        var variantTitle = titleParts[1] || '';

        var onSale = comparePrice && parseInt(comparePrice) > parseInt(price);

        upsellsHtml += '<div class="cart-upsell__item">';
        upsellsHtml += '<a href="' + product.url + '" class="cart-upsell__image-link">';
        upsellsHtml += '<img src="' + imgSrc + '" alt="' + mainTitle + '" class="cart-upsell__image">';
        upsellsHtml += '</a>';
        upsellsHtml += '<div class="cart-upsell__details">';
        upsellsHtml += '<a href="' + product.url + '" class="cart-upsell__title">' + mainTitle + '</a>';
        if (variantTitle) {
          upsellsHtml += '<span class="cart-upsell__variant">' + variantTitle + '</span>';
        }
        upsellsHtml += '<div class="cart-upsell__price">';
        if (onSale) {
          upsellsHtml += '<span class="cart-upsell__price--compare">$' + comparePrice + '</span> ';
        }
        upsellsHtml += '<span class="cart-upsell__price--current">$' + price + '</span>';
        upsellsHtml += '</div>';
        upsellsHtml += '</div>';
        var handle = product.handle || (product.url ? product.url.replace('/products/', '') : '');
  if (!window.XOCustomCards || !window.XOCustomCards.isCustom(product)) {
  upsellsHtml += '<button class="upsell-add-btn" data-variant-id="' + variantId + '" data-handle="'
   + handle + '">+ Add</button>';
  }
        upsellsHtml += '</div>';
      });

      upsellsHtml += '</div></div>';

      var $cartItems = $('.ajaxcart__row, .cart__row, .cart-item').last();
      if ($cartItems.length) {
        $cartItems.after(upsellsHtml);
      } else {
        $cartContainer.find('.ajaxcart__product, .cart__items, .cart-items').first().after(upsellsHtml);
      }

      window.buildingUpsells = false;
    }

    // Fetch product tags, then both APIs in parallel: Recs for API picks, Search for title picks
    var handle = firstItem.handle || firstItem.url.replace('/products/', '').split('?')[0];
    $.getJSON('/products/' + handle + '.js', function(sourceProduct) {
      sourceTags = (sourceProduct.tags || []).map(function(t) { return t.toLowerCase(); });
      sourceType = (sourceProduct.type || '').toLowerCase();
      // Detect occasion for scoring + backfill
      sourceTags.forEach(function(tag) {
        if (!sourceOccasion) {
          for (var oi = 0; oi < occasionKeys.length; oi++) {
            if (tag.indexOf(occasionKeys[oi]) !== -1) { sourceOccasion = occasionKeys[oi]; break; }
          }
        }
      });
    }).always(function() {
      var productOccasion = sourceOccasion;

      var recsReq = $.getJSON('/recommendations/products.json?product_id=' + productId + '&limit=12');
      var searchReq = searchTerm
        ? $.getJSON('/search/suggest.json?q=' + encodeURIComponent(searchTerm) + '&resources[type]=product&resources[limit]=10')
        : $.Deferred().resolve({});
      var occasionCollectionMap = {
        'bachelorette': 'bachelorette-party-decorations',
        'birthday': 'birthday-party-decorations',
        'baby shower': 'baby-shower',
        'bridal shower': 'bridal-shower',
        'kids party': 'kids-party',
        'halloween': 'halloween',
        'christmas': 'christmas',
        'holiday': 'holiday',
        'st patricks': 'st-pattys-day-%E2%98%98%EF%B8%8F',
        'easter': 'easter',
        'valentines': 'valentines-day',
        'new years': 'new-years'
      };
      var occasionCollection = occasionCollectionMap[productOccasion] || '';
      var occasionReq = occasionCollection
        ? $.getJSON('/collections/' + occasionCollection + '/products.json?sort_by=best-selling&limit=10')
        : $.Deferred().resolve({});

      $.when(recsReq, searchReq, occasionReq).then(function(recsResp, searchResp, occasionResp) {
        var recsData = recsResp[0] || recsResp;
        var searchData = searchResp[0] || searchResp;
        var occasionData = occasionResp[0] || occasionResp;

        var recsAll = (recsData.products || []).filter(function(p) {
          return cartProductIds.indexOf(p.id) === -1;
        });

        var searchAll = [];
        if (searchData.resources && searchData.resources.results && searchData.resources.results.products) {
          searchAll = searchData.resources.results.products.filter(function(p) {
            return cartProductIds.indexOf(p.id) === -1;
          });
        }

        var occasionAll = (occasionData.products || []).filter(function(p) {
          return cartProductIds.indexOf(p.id) === -1;
        });

        // API picks: from recs, diversified by type, skip same type
        recsAll.forEach(function(p) { p._score = relevanceScore(p); });
        recsAll.sort(function(a, b) { return b._score - a._score; });

        var apiPicks = [];
        var usedTypes = {};
        for (var i = 0; i < recsAll.length; i++) {
          if (recsAll[i]._score < 0) continue;
          var t = (recsAll[i].type || 'unknown').toLowerCase();
          if (t === sourceType) continue;
          if (!usedTypes[t]) {
            usedTypes[t] = true;
            apiPicks.push(recsAll[i]);
          }
        }

        // Title pool: require 2+ LINE keyword hits when multiple line words exist
        var typeWords = ['confetti','sunglasses','sunnies','sash','cups','cup','banner','balloon','balloons','hat','hats','headband','tiara','necklace','tattoos','tats','stickers','napkins','plates','plate','straws','bags','tote','candle','candles','pin','pins','mask','bandana','journal','notebook','scarf','clip','bow','tray','dish','straw','ring','pearl','garland','tablecloth','backdrop','crowns','crown','wand','glasses','beads','lei','flask','tumbler','mug','keychain','magnet','patch','shirt','tank','top','toppers','topper','cupcake','cupcakes','liners','liner','wrappers','wrapper','decor','supplies','favors','centerpiece','centerpieces','veil','veils','pouches','pouch','koozies','koozie','coasters','coaster','picks','sign','signs','float','chain','fan','headscarf','streamers','streamer','game','towel','saucers'];
        var occasionWords = ['birthday','bday','bachelorette','bach','bridal','bride','wedding','baby','shower','kids','halloween','christmas','holiday','easter','valentines','engagement','retirement','graduation'];
        var lineKeywords = titleKeywords.filter(function(kw) { return typeWords.indexOf(kw) === -1 && occasionWords.indexOf(kw) === -1; });
        var minHits = Math.min(2, lineKeywords.length);
        var titlePool = searchAll.filter(function(p) {
          var recWords = p.title.toLowerCase().replace(/[^a-z0-9\s]/g, '').split(/\s+/);
          var hits = 0;
          lineKeywords.forEach(function(kw) { if (recWords.indexOf(kw) !== -1) hits++; });
          p._titleHits = hits;
          return hits >= minHits;
        });
        titlePool.sort(function(a, b) { return b._titleHits - a._titleHits; });

        // If 2+ strong title matches exist, always max out title picks first
        var isBirthdayOrParty = (productOccasion === 'birthday' || productOccasion === 'kids party' || !productOccasion);
        var pattern;
        if (titlePool.length >= 2) {
          pattern = ['title', 'title', 'title'];
        } else if (isBirthdayOrParty) {
          pattern = ['title', 'api', 'title'];
        } else {
          pattern = ['api', 'title', 'api'];
        }

        var picked = [];
        var usedIds = {};
        var ai = 0, ti = 0;

        function pickFrom(pool, idx) {
          while (idx < pool.length) {
            if (!usedIds[pool[idx].id]) {
              usedIds[pool[idx].id] = true;
              picked.push(pool[idx]);
              return idx + 1;
            }
            idx++;
          }
          return idx;
        }

        for (var s = 0; s < 3; s++) {
          var before = picked.length;
          if (pattern[s] === 'api') {
            ai = pickFrom(apiPicks, ai);
          } else {
            ti = pickFrom(titlePool, ti);
          }
          if (picked.length === before) {
            if (pattern[s] === 'api') {
              ti = pickFrom(titlePool, ti);
            } else {
              ai = pickFrom(apiPicks, ai);
            }
          }
          if (picked.length === before) {
            for (var oi = 0; oi < occasionAll.length; oi++) {
              var op = occasionAll[oi];
              var ot = (op.product_type || op.type || '').toLowerCase();
              if (!usedIds[op.id] && ot !== sourceType) {
                usedIds[op.id] = true;
                picked.push(op);
                break;
              }
            }
          }
        }

        // Smart backfill from occasion search (type-diversified, skip same type)
        if (picked.length < 3 && occasionAll.length > 0) {
          for (var b = 0; b < occasionAll.length && picked.length < 3; b++) {
            var bp = occasionAll[b];
            var bt = (bp.product_type || bp.type || '').toLowerCase();
            if (!usedIds[bp.id] && bt !== sourceType) {
              usedIds[bp.id] = true;
              picked.push(bp);
            }
          }
        }

        if (picked.length > 0) {
          renderUpsells(picked);
        } else {
          window.buildingUpsells = false;
        }
      }, function() {
        window.buildingUpsells = false;
      });
    });
  }

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  var wholesaleConfirmed, wholesaleDisplayed = [], wholesaleSaving = false, wholesaleTimer;
  var wholesalePending = {}, wholesaleCheckout = false;

  function wholesalePreview() {
    if (!wholesaleConfirmed) return;
    var total = wholesaleConfirmed.total_price, count = wholesaleConfirmed.item_count;
    var qualifyingSubtotal = wholesaleConfirmed.original_total_price;
    wholesaleConfirmed.items.forEach(function(item) {
      if (!Object.prototype.hasOwnProperty.call(wholesalePending, item.key)) return;
      var delta = wholesalePending[item.key] - item.quantity;
      total += delta * item.final_price;
      qualifyingSubtotal += delta * item.original_price;
      count += delta;
    });
    $cartContainer.find('.cart_subtotal_wrapp .one-third p').first().html(slate.Currency.formatMoney(total, settings.moneyFormat));
    $cartCountSelector.html(count);
    $('#inner_count').text(count + (count === 1 ? ' Item' : ' Items'));
    $cartContainer.find('[data-wholesale-drawer-status]').text('Saving...');
    $cartContainer.find('.cart__checkout').prop('disabled', !Number.isFinite(qualifyingSubtotal) || qualifyingSubtotal < 10000 || !count);
  }

  function wholesaleQueue(line, qty, input) {
    var item = wholesaleDisplayed[line - 1];
    if (!item) return;
    if (input) input.val(qty);
    wholesalePending[item.key] = qty;
    wholesalePreview();
    window.clearTimeout(wholesaleTimer);
    wholesaleTimer = window.setTimeout(wholesaleFlush, 120);
  }

  function wholesaleFlush() {
    window.clearTimeout(wholesaleTimer);
    if (wholesaleSaving) return;
    if (!Object.keys(wholesalePending).length) {
      if (wholesaleCheckout) {
        wholesaleCheckout = false;
        $.ajax({url: '/cart.js', dataType: 'json', cache: false}).done(function(cart) {
          updateCountPrice(cart);
          buildCart(cart);
          if (cart.item_count && !wholesaleCartMessage(cart)) window.location.assign('/checkout');
        }).fail(function() {
          $cartContainer.find('[data-wholesale-drawer-status]').text('Could not verify your cart. Please try again.');
        });
      }
      return;
    }
    wholesaleSaving = true;
    var sent = Object.assign({}, wholesalePending);
    var ready = window.wholesaleMainCart ? window.wholesaleMainCart.flush() : Promise.resolve();
    ready.then(function() {
      var previous = window.wholesaleCartWrite || Promise.resolve();
      var request = previous.catch(function() {}).then(function() {
        return $.ajax({url: '/cart/update.js', type: 'POST', contentType: 'application/json', dataType: 'json', data: JSON.stringify({updates: sent})});
      });
      window.wholesaleCartWrite = request;
      return request;
    }).then(function(cart) {
      wholesaleSaving = false;
      wholesaleConfirmed = cart;
      Object.keys(sent).forEach(function(key) {
        if (wholesalePending[key] === sent[key]) delete wholesalePending[key];
      });
      if (window.wholesaleMainCart) window.wholesaleMainCart.receive(cart);
      if (Object.keys(wholesalePending).length) {
        wholesalePreview();
        wholesaleFlush();
      } else {
        updateCountPrice(cart);
        buildCart(cart);
        wholesaleFlush();
      }
    }).catch(function(error) {
      console.error('Wholesale cart update failed:', error && (error.message || error.statusText));
      wholesaleSaving = false;
      wholesaleCheckout = false;
      wholesalePending = {};
      $.ajax({url: '/cart.js', dataType: 'json', cache: false}).done(function(cart) {
        updateCountPrice(cart);
        buildCart(cart);
        if (window.wholesaleMainCart) window.wholesaleMainCart.receive(cart);
        $cartContainer.find('[data-wholesale-drawer-status]').text('Could not save changes. Check quantities and try again.');
      }).fail(function() {
        $cartContainer.find('[data-wholesale-drawer-status]').text('Could not reload cart. Reload this page before checkout.');
        $cartContainer.find('.cart__checkout').prop('disabled', true);
      });
    });
  }

  adjustCart = function() {
    if (isWholesaleCart()) {
      document.addEventListener('click', function(event) {
        var checkout = event.target.closest('.cart-drawer .cart__checkout');
        if (!checkout) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        wholesaleCheckout = true;
        wholesaleFlush();
      }, true);
      window.wholesaleDrawerReceive = function(cart) {
        if (wholesaleSaving || Object.keys(wholesalePending).length) return;
        updateCountPrice(cart);
        buildCart(cart);
      };
      $body.on('input', '.ajaxcart__qty-num', function() {
        var value = String($(this).val()), qty = Number(value);
        if (value.trim() && Number.isSafeInteger(qty) && qty >= 0) wholesaleQueue($(this).data('line'), qty === 0 ? 0 : Math.max(5, qty));
      });
    }
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isWholesaleCart()) {
        var control = $(this), line = control.data('line');
        var input = $cartContainer.find('.ajaxcart__qty-num').filter(function() { return $(this).data('line') === line; });
        var qty = Number(input.val());
        if (!Number.isSafeInteger(qty) || qty < 0) qty = 5;
        qty = control.hasClass('ajaxcart__qty--remove') ? 0 : Math.max(5, qty + (control.hasClass('ajaxcart__qty--plus') ? 1 : -1));
        wholesaleQueue(line, qty, input);
        return false;
      }
      if (isUpdating) {
        return;
      }
      var $el = $(this);
      var line;
      var $qtySelector;
      var qty;
      if ( $el.hasClass('ajaxcart__qty--remove') ) {
        qty = 0;
        line = $el.data('line');
      } else {
        line = $el.data('line'),
          $qtySelector = $el.parents('.table').find('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        qty = validateQty(qty);

        if ($el.hasClass('ajaxcart__qty--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 0) qty = 0;
        }
      }

      if (line) {
        if (isWholesaleCart() && !$el.hasClass('ajaxcart__qty--remove')) qty = Math.max(5, qty);
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isWholesaleCart()) {
        var input = $(this), value = String(input.val()), qty = Number(value);
        if (!value.trim() || !Number.isSafeInteger(qty) || qty < 0) qty = 5;
        wholesaleQueue(input.data('line'), qty === 0 ? 0 : Math.max(5, qty), input);
        return;
      }
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      if (line) {
        if (isWholesaleCart()) {
          var enteredQty = Number($el.val());
          qty = Number.isSafeInteger(enteredQty) && enteredQty >= 0 && $el.val().trim() !== '' ? enteredQty : 5;
          if (qty > 0) qty = Math.max(5, qty);
        }
        updateQuantity(line, qty);
      }
    });

    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isWholesaleCart()) {
        evt.preventDefault();
        wholesaleCheckout = true;
        wholesaleFlush();
        return;
      }
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
        'is-loading'
      );

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      ShopifyAPI.updateCartNote(newNote, function() {});
    });
  };

  adjustCartCallback = function(cart) {
    updateCountPrice(cart);

    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
      isUpdating = false;
    }, 150);
  };

  qtySelectors = function() {
    var $numInputs = $('input[type="number"]');

    if ($numInputs.length) {
      $numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source = $('#JsQty').html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        $el.after(template(data)).remove();
      });

      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            $qtySelector = $el.parents('.table').find('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        qty = validateQty(qty);

        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;
})(ajaxCart || {}, jQuery);
